<template>
    <Link :href="'/'">
        <img class="w-60 mx-auto" src="/img/logo.png" alt="cookiepop logo">
    </Link>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';

    export default defineComponent({
        components: {
            Link,
        },
    })
</script>
